import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SnackbarProvider } from 'notistack';
import { persistor, store } from './redux/store';
//
import App from './App';
import './scss/main.scss';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Suspense>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </HelmetProvider>
);
